import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import * as d3 from 'd3';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-treechart',
  templateUrl: './treechart.component.html',
  styleUrls: ['./treechart.component.scss']
})
export class TreechartComponent {

  @ViewChild('orgTree', { static: true }) orgTree: ElementRef | undefined;


  orgUnits: any[] = []; // Replace with your data structure
  @Input() data: any;


  async ngOnInit(): Promise<void> {
    // Define your data here
    const data = await this.getDataFromArg(this.data);

    // Call the D3.js tree hierarchy function
    this.createOrgTree(data);
  }

  ngAfterViewInit(): void {
    // Do any additional setup after the view is initialized
  }

  private createOrgTree(data: any): void {
    const margin = { top: 20, right: 120, bottom: 20, left: 120 };
    const width = 960 - margin.right - margin.left;
    const height = 500 - margin.top - margin.bottom;

    const tree = d3.tree().size([width, height]);

    if(this.orgTree) {

      const svg = d3.select(this.orgTree.nativeElement)
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      const root = d3.hierarchy(data);
      tree(root);

      const link = svg.selectAll('.link')
        .data(root.descendants().slice(1))
        .enter().append('path')
        .attr('class', 'link')
        .attr('d', (d: any) => {
          return 'M' + d.x + ',' + d.y
            + 'C' + d.x + ',' + (d.y + d.parent.y) / 2
            + ' ' + d.parent.x + ',' + (d.y + d.parent.y) / 2
            + ' ' + d.parent.x + ',' + d.parent.y;
        });

      const node = svg.selectAll('.node')
        .data(root.descendants())
        .enter().append('g')
        .attr('class', 'node')
        .attr('transform', (d: any) => 'translate(' + d.x + ',' + d.y + ')');

      node.append('circle')
        .attr('r', 5);

      node.append('text')
        .attr('dy', '.35em')
        .attr('x', (d: any) => d.children ? -13 : 13)
        .style('text-anchor', (d: any) => d.children ? 'end' : 'start')
        .text((d: any) => d.data.name);

    }
    
  }

  constructor( private dataService: DataService,) {}

  async getDataFromArg(data: any) {
    let res = await this.dataService.postData('dashboards/dynamic-aggregation', {
      "aggregation": data.aggregation,
      "tableName": data.table
    }); 

    return res.data;
  }

}
